var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 842,
    viewBox: "0 0 1920 842",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_1581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1041 1346.08C1041 1723.89 728.271 1346.08 342.5 1346.08C-43.2709 1346.08 -356 1723.89 -356 1346.08C-356 968.275 -43.2709 662 342.5 662C728.271 662 1041 968.275 1041 1346.08Z",
    fill: "#FFB8EF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_1581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2895 1274.08C2895 1651.89 2582.27 1274.08 2196.5 1274.08C1810.73 1274.08 1498 1651.89 1498 1274.08C1498 896.275 1810.73 590 2196.5 590C2582.27 590 2895 896.275 2895 1274.08Z",
    fill: "#CB76FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_1581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1558 1564.08C1558 1941.89 1245.27 1564.08 859.5 1564.08C473.729 1564.08 161 1941.89 161 1564.08C161 1186.28 473.729 880 859.5 880C1245.27 880 1558 1186.28 1558 1564.08Z",
    fill: "#C76CFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_0_1581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1733.5 1229.25C1776.6 1390.11 1507.97 1289.68 1229.77 1364.23C951.568 1438.77 769.142 1660.05 726.041 1499.2C682.94 1338.35 873.527 1147.52 1151.73 1072.97C1429.93 998.43 1690.4 1068.4 1733.5 1229.25Z",
    fill: "#04C3FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_0_1581)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -157,
    cy: 730,
    r: 330,
    fill: "#00D1FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1581",
    x: -756,
    y: 262,
    width: 2197,
    height: 1652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_0_1581"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_1581",
    x: 1098,
    y: 190,
    width: 2197,
    height: 1652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_0_1581"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_1581",
    x: -239,
    y: 480,
    width: 2197,
    height: 1652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_0_1581"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_1581",
    x: 319.959,
    y: 643.142,
    width: 1818.12,
    height: 1313.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_0_1581"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_0_1581",
    x: -887,
    y: 0,
    width: 1460,
    height: 1460,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_0_1581"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/footerBg.c014c7f984f94cf63b487550e214df05.svg";
export { ForwardRef as ReactComponent };